import React, { useEffect, useState } from 'react';
import { Button, Modal, Form, InputGroup, Row, Col, Image,ToastContainer,Toast } from 'react-bootstrap';
import axios from 'utils/axiosInstance';
import useAxiosFlowFunction from 'hooks/useAxiosFlowFunction';
import { subscriptionOffers, enablesubscriptionoffers,eventapi } from 'utils/envsetup';
import 'pages/WorkSpace/workspace.scss';
import workSpaceStyle from 'pages/WorkSpace/workSpace.module.scss';
import { useSelector } from 'react-redux';
import useEventTrace from 'utils/CommonRequestConfig';

function OfferPopup(props) {
  const [, , , axiosFetch] = useAxiosFlowFunction({});
  const [response, setResponse] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [userData, setUserData] = useState({ name: '', phone: '' });
  const [errors, setErrors] = useState({ name: false, phone: false });
  const [formIncomplete, setFormIncomplete] = useState(true);
  const accountResponse = useSelector(state => state?.workSpace?.subscriptionPlanDetails);
  const usrId = useSelector(state => state.commonData?.userProfile?.userId);
  const {getProductTourReqConfig} = useEventTrace();
  const [loading, setLoading] = useState(false);
  const [show,setShow]=useState(false)
  const updateWorkspaceUserEvent = async (submodule,action) => {
    const reqBody = getProductTourReqConfig()
    try {
      await axiosFetch({
        axiosInstance: axios,
        method: 'POST',
        url: eventapi,
        requestConfig: {
           ...reqBody,
           eventModule:'OFFERS',
           eventSubModule:submodule,
           eventAction:action,
        },
      });
    } catch (error) { 
    }
  };
  const handleSubmit = async () => {
    const reqObj = {
      name: userData?.name,
      phoneNo: userData?.phone,
      email: accountResponse?.email,
      offerName: response && response[0]?.offerDetails[0]?.targetPlan,
      offerAmount: response && response[0]?.offerDetails[0]?.offerAmount,
      userId:usrId
    };
    try {
      setLoading(true); 
      const res = await axiosFetch({
        axiosInstance: axios,
        method: 'POST',
        url: enablesubscriptionoffers,
        requestConfig: reqObj,
      });
      if (res?.status === "Success") {
        setShow(true)
      } else {
      }
    } catch (error) {}
    setLoading(false);
    setIsOpen(false);
    if (props?.type === 'deploy') {
      props?.handleDeploy();
      props?.updateWorkspaceUserEvent('DEPLOY');
    }
  };
  const fetchOfferDetails = async () => {
    try {
      const res = await axiosFetch({
        axiosInstance: axios,
        method: 'GET',
        url: subscriptionOffers,
        requestConfig: {},
      });
      if (res && res?.length > 0) {
        const updatedRes = res.map(offer => {
          const offerDetail = offer?.offerDetails[0];
          offer.offerDescription = offer?.offerDescription
            .replace('{offerAmount}', offerDetail?.offerAmount)
            .replace(
              '{originalAmount}',
              ` <span style="text-decoration: line-through;">(${offerDetail?.originalAmount})</span> `,
            );
          return offer;
        });
        setResponse(updatedRes);
      } else {
        setResponse([]);
      }
    } catch (error) {}
  };

  useEffect(() => {
    fetchOfferDetails();
  }, []);

  const handleInputChange = (field, value) => {
    if (field === 'phone') {
      const newVal = value?.replace(/\D/g, '');
      setUserData({ ...userData, [field]: newVal });
    } else {
      setUserData({ ...userData, [field]: value });
    }
    if (errors[field]) {
      setErrors({ ...errors, [field]: false });
    }
    checkFormComplete();
  };

  const validateField = (field, value) => {
    let error = false;
    if (field === 'name') {
      error = !value;
    } else if (field === 'phone') {
      error = !value || !/^\d{10}$/.test(value);
    }
    setErrors({ ...errors, [field]: error });
    return error;
  };

  const checkFormComplete = () => {
    const { name, phone } = userData;
    setFormIncomplete(!name || !phone);
  };

  return (
    <>
      {response && accountResponse?.phaseType === 'TRIAL' && props?.type === 'appsetting' && (
        <div className="appoffer-popup-container">
          <div
            className="offerpopupcss"
            style={{ display: 'flex', width: '795px',paddingBottom:10}}
          >
            {response?.map(res => {
              return (
                <>
                  <div style={{ padding: '10px 10px 0px 18px' ,width:'80%'}}>
                    <div className="offerpopuptitle">{res?.offerTitle}</div>
                    {res?.offerDescription?.split('\\n')?.map((line) => (
              <>
          <span  className="offerpopuptext" dangerouslySetInnerHTML={{ __html:line }} />

                <br />
              </>))}
                  </div>
                  <div style={{ textAlign: 'right', padding: '19px 10px 0px 0px' }}>
                    <Button
                      className="offerpopupbutton"
                      onClick={() => {
                        setIsOpen(true);
                        updateWorkspaceUserEvent('APP_SETTINGS','PROCEED_OFFER')
                      }}
                    >
                     Avail Offer
                    </Button>
                  </div>
                </>
              );
            })}
          </div>
        </div>
      )}
      {(props?.isOfferPopupShow || props?.openPopup)&&
        response &&
        accountResponse?.phaseType === 'TRIAL' &&
        props?.type !== 'appsetting' && (
          <div className="offer-popup-container">
            <div
              className="offerpopupcss"
              style={{
                width: '466px',
                height: '220px',
                alignItems: props?.type === 'deploy' ? 'center' : '',
              }}
            >
              <div style={{ textAlign: 'right', padding: '19px 22px 0px 0px' }}>
                <span
                  className="icon-ico_close align-right"
                  style={{ fontWeight: 600, cursor: 'pointer', color: '#FFFFFF' }}
                  onClick={() => {
                    if (props?.type === 'deploy') {updateWorkspaceUserEvent('DEPLOY','CLOSE_OFFER')
                      props?.setOpenPopup(false)
                      props?.handleDeploy();
                      props?.updateWorkspaceUserEvent('DEPLOY');
                    }
                  else{
                    props?.setIsOfferPopupShow(false)
                    updateWorkspaceUserEvent('AUTO_DISPLAY','CLOSE_OFFER')

                  }
                  }}
                ></span>
              </div>
              {response?.map(res => {
                return (
                  <>
                    <div style={{ padding: '0px 100px 0px 28px' }}>
                      <div className="offerpopuptitle">{res?.offerTitle}</div>
                       {res?.offerDescription?.split('\\n')?.map((line) => (
              <>
          <span  className="offerpopuptext" dangerouslySetInnerHTML={{ __html:line }} />

                <br />
              </>))}
                      <Button
                        className="offerpopupbutton"
                        style={{ marginTop: 23 }}
                        onClick={() => {
                          setIsOpen(true);
                          if(props?.type === 'deploy'){
                            props?.setOpenPopup(false)
                            updateWorkspaceUserEvent('DEPLOY','PROCEED_OFFER')
                          }
                          else{
                            props?.setIsOfferPopupShow(false);
                            updateWorkspaceUserEvent('AUTO_DISPLAY','PROCEED_OFFER')
                          }
                        }}
                      >
                       Avail Offer
                      </Button>
                    </div>
                  </>
                );
              })}
            </div>
          </div>
        )}

      <Modal
        className={workSpaceStyle['deletemodal']}
        show={isOpen}
        onHide={() => {
          setIsOpen(false);
          updateWorkspaceUserEvent('OFFER_FORM','CLOSE_OFFER')
          if (props?.type === 'deploy') {
            props?.handleDeploy();
            props?.updateWorkspaceUserEvent('DEPLOY');
          }
        }}
        backdrop="static"
        keyboard={false}
        centered
        style={{ zIndex: 9999999999 }}
      >
        <Modal.Header closeButton style={{ borderBottom: 'none' }}>
        </Modal.Header>
        <Modal.Body className={workSpaceStyle['delmodalcont']} style={{ paddingTop: 0 }}>
        {loading && (
            <div className="loadingdotstyl" style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(255, 255, 255, 0.7)', zIndex: 1000 }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '100%',
                }}
              >
                <div
                  className="loading-dots-container"
                  style={{
                    display: 'flex',
                    width: '50px',
                    height: '20px',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <div style={{ animationDelay: '-0.4s' }}></div>
                  <div style={{ animationDelay: '-0.2s' }}></div>
                  <div style={{ animationDelay: '0s' }}></div>
                </div>
              </div>
            </div>
          )}
          {/* <div style={{ display: 'flex', paddingBottom: '10px' }}>
            <div
              style={{
                backgroundColor: '#CCF3FF',
                borderRadius: '8px',
                padding: '10px 6px',
                width: '100%',
              }}
            >
              <span className="icon-ico_info" style={{ color: '#095C77' }} />
              <span
                className="acccontenttitl"
                style={{ color: '#095C77', paddingLeft: '5px', fontSize: '14px' }}
              >
                Please enter your details for our support team to reach you.
              </span>
            </div>
          </div> */}
                   <div style={{fontWeight:600,marginBottom:20}}>Please provide below details and Our team will call you to get you started on the offer.</div>
          <Form>
            <Form.Group controlId="formName" className="marginbillcss">
              <Form.Label className="billpopupinfolabel">
                Name<span style={{ color: 'red' }}>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Name"
                className="billpopupinfoValueInput"
                value={userData.name}
                onChange={e => handleInputChange('name', e.target.value)}
                onBlur={e => validateField('name', e.target.value)}
                isInvalid={errors.name}
              />
              <Form.Control.Feedback type="invalid">Name is Required</Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="marginbillcss">
              <Form.Label className="billpopupinfolabel">
                Phone <span style={{ color: 'red' }}>*</span>
              </Form.Label>
              <InputGroup>
                <InputGroup.Text style={{ border: 'none', height: 40, marginTop: 8 }}>
                  +91
                </InputGroup.Text>
                <Form.Control
                  type="tel"
                  className="billpopupinfoValueInput"
                  placeholder="Enter Phone Number"
                  value={userData.phone}
                  onChange={e => handleInputChange('phone', e.target.value)}
                  onBlur={e => validateField('phone', e.target.value)}
                  isInvalid={errors.phone}
                />
                <Form.Control.Feedback type="invalid">
                  Invalid phone number please enter 10 digits
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>
            {/* {(errors.name || errors.phone) && (
              <div className="billerrorinfo">
                <Image style={{ marginRight: 5 }} src="assets/svg/errorinfo.svg" />
                Fill the Name and Phone to proceed
              </div>
            )} */}
            <Row style={{ justifyContent: 'right', margin: '8px 0px 0px 0px' }}>
              <Col sm={5} style={{ paddingLeft: 7, paddingRight: 0 }}>
                <Button
                  style={{ width: '100%' }}
                  className="updatedetailbut"
                  onClick={()=>{handleSubmit()
                    updateWorkspaceUserEvent('OFFER_FORM','SUBMIT_OFFER')
                  }}
                  disabled={errors.name || errors.phone || formIncomplete}
                >
                  Submit
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
      <ToastContainer
        className="p-3 paymentlinktoast"
        position="top-center"
        style={{ zIndex: 99999 }}
      >
        <Toast className='toastcss' onClose={() => setShow(false)} show={show} delay={3000} autohide>
          <Toast.Header
            style={{ backgroundColor: 'rgb(176 237 207)', borderRadius: '4px', border: 'none',fontSize:'16px',zIndex:'9999999999' }}
          >
          Our support team will reach out to you shortly.
          </Toast.Header>
        </Toast>
      </ToastContainer>   
    </>
  );
}

export default OfferPopup;
